<template>
  <div class="searchHospitalWrap">
    <div :class="parentClass()">
      <div class="searchHospital_map"></div>
      <div class="searchHospital_inner">
        <div class="searchHospital_first">
          <p class="searchHospital_description">
            希望するエリアを<br class="hiddenPc" />選択してください。
          </p>
          <ul>
            <li v-for="(item, i) in area" :key="i">
              <div :class="firstButtonsClass(item)">
                <button v-html="item.label" @click="jumpSecond(item)"></button>
              </div>
            </li>
          </ul>
        </div>
        <div class="searchHospital_second">
          <div class="searchHospital_areaLabel">
            <p class="name">{{ state.currentArea.label }}</p>
            <div class="backWrap">
              <button type="button" class="back" @click="jumpFirst">
                全国に戻る
              </button>
            </div>
          </div>
          <ul class="searchHospital_choiceArea">
            <li v-for="(item, i) in state.currentArea.children" :key="i">
              <div>
                <button class="choiceButton" @click="jumpThird(item)">
                  <span v-html="item.label"></span>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'SearchHospital',

  setup() {
    const router = useRouter()

    type StateTypes = {
      currentView: 'first' | 'second'
      currentArea: {
        id: string
        label: string
        children: {
          label: string
        }[]
      }
    }

    const state = reactive<StateTypes>({
      currentView: 'first',
      currentArea: {
        id: '',
        label: '全国',
        children: []
      }
    })

    type AreaTypes = {
      id: string
      label: string
      arrow: string
      children: {
        id: string
        label: string
      }[]
    }

    const area: AreaTypes[] = [
      {
        id: 'hokkaidoTohoku',
        label: '北海道<span class="br"></span>・<span class="br"></span>東北',
        arrow: 'left',
        children: [
          { id: '1', label: '北海道' },
          { id: '2', label: '青森県' },
          { id: '3', label: '岩手県' },
          { id: '4', label: '宮城県' },
          { id: '5', label: '秋田県' },
          { id: '6', label: '山形県' },
          { id: '7', label: '福島県' }
        ]
      },
      {
        id: 'kanto',
        label: '関東',
        arrow: 'left',
        children: [
          { id: '13', label: '東京都' },
          { id: '14', label: '神奈川県' },
          { id: '12', label: '千葉県' },
          { id: '11', label: '埼玉県' },
          { id: '8', label: '茨城県' },
          { id: '9', label: '栃木県' },
          { id: '10', label: '群馬県' }
        ]
      },
      {
        id: 'koshinetsuHokuriku',
        label: '甲信越<span class="br"></span>・<span class="br"></span>北陸',
        arrow: 'bottom',
        children: [
          { id: '15', label: '新潟県' },
          { id: '16', label: '富山県' },
          { id: '17', label: '石川県' },
          { id: '18', label: '福井県' },
          { id: '19', label: '山梨県' },
          { id: '20', label: '長野県' }
        ]
      },
      {
        id: 'tokaiChubu',
        label: '東海<span class="br"></span>・<span class="br"></span>中部',
        arrow: 'top',
        children: [
          { id: '23', label: '愛知県' },
          { id: '22', label: '静岡県' },
          { id: '21', label: '岐阜県' },
          { id: '24', label: '三重県' }
        ]
      },
      {
        id: 'chugokuShikoku',
        label: '中国<span class="br"></span>・<span class="br"></span>四国',
        arrow: 'bottom',
        children: [
          { id: '31', label: '鳥取県' },
          { id: '32', label: '島根県' },
          { id: '33', label: '岡山県' },
          { id: '34', label: '広島県' },
          { id: '35', label: '山口県' },
          { id: '36', label: '徳島県' },
          { id: '37', label: '香川県' },
          { id: '38', label: '愛媛県' },
          { id: '39', label: '高知県' }
        ]
      },
      {
        id: 'kinki',
        label: '近畿',
        arrow: 'top',
        children: [
          { id: '27', label: '大阪府' },
          { id: '26', label: '京都府' },
          { id: '28', label: '兵庫県' },
          { id: '29', label: '奈良県' },
          { id: '25', label: '滋賀県' },
          { id: '30', label: '和歌山県' }
        ]
      },
      {
        id: 'kyushuOkinawa',
        label: '九州<span class="br"></span>・<span class="br"></span>沖縄',
        arrow: 'top',
        children: [
          { id: '40', label: '福岡県' },
          { id: '41', label: '佐賀県' },
          { id: '42', label: '長崎県' },
          { id: '43', label: '熊本県' },
          { id: '44', label: '大分県' },
          { id: '45', label: '宮崎県' },
          { id: '46', label: '鹿児島県' },
          { id: '47', label: '沖縄県' }
        ]
      }
    ]

    const parentClass = () => {
      return {
        searchHospital: true,
        second: state.currentView === 'second',
        hokkaidoTohoku: state.currentArea.id === 'hokkaidoTohoku',
        kanto: state.currentArea.id === 'kanto',
        koshinetsuHokuriku: state.currentArea.id === 'koshinetsuHokuriku',
        tokaiChubu: state.currentArea.id === 'tokaiChubu',
        chugokuShikoku: state.currentArea.id === 'chugokuShikoku',
        kinki: state.currentArea.id === 'kinki',
        kyushuOkinawa: state.currentArea.id === 'kyushuOkinawa'
      }
    }

    const firstButtonsClass = (item: AreaTypes) => {
      return {
        balloon: true,
        arrowLeft: item.arrow === 'left',
        arrowTop: item.arrow === 'top',
        arrowRight: item.arrow === 'right',
        arrowBottom: item.arrow === 'bottom',
        hokkaidoTohoku: item.id === 'hokkaidoTohoku',
        kanto: item.id === 'kanto',
        koshinetsuHokuriku: item.id === 'koshinetsuHokuriku',
        tokaiChubu: item.id === 'tokaiChubu',
        chugokuShikoku: item.id === 'chugokuShikoku',
        kinki: item.id === 'kinki',
        kyushuOkinawa: item.id === 'kyushuOkinawa'
      }
    }

    const jumpThird = (item: AreaTypes) => {
      router.push(`/search/hospital/list/pr_${item.id}`)
      document.cookie = `searchAreaHome=${item.id}; max-age=31536000; path=/`
    }

    const jumpSecond = (item: AreaTypes) => {
      state.currentView = 'second'
      state.currentArea.id = item.id
      state.currentArea.label = item.label.replace(
        /<("[^"]*"|'[^']*'|[^'">])*>/g,
        ''
      )
      state.currentArea.children = item.children
    }

    const jumpFirst = () => {
      state.currentView = 'first'
      state.currentArea.id = ''
      state.currentArea.label = ''
      state.currentArea.children = []
    }

    return {
      state,
      area,
      parentClass,
      firstButtonsClass,
      jumpThird,
      jumpSecond,
      jumpFirst
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.searchHospitalWrap {
  @include mixins.mediaMax() {
    margin-left: -16px;
    margin-right: -16px;
  }
}

.searchHospital {
  overflow: hidden;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  margin-bottom: 30px;
  padding-bottom: 101.8%;
  transition: background 0.2s ease;
  background-color: var.$color-secondary;

  @include mixins.media() {
    height: 350px;
    padding-bottom: 0;
    margin-bottom: 0;
  }
}

.searchHospital_map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform 0.2s ease;
  background: #e5f7f6 url(~@/assets/images/home/bg-map.svg) no-repeat;
  background-size: 100%;
  transform: scale(0.91) translate(0, 1.3vw);

  .hokkaidoTohoku & {
    transform: scale(5.71) translate(-26.9vw, 21.2vw);
  }

  .kanto & {
    transform: scale(5.71) translate(-21.5vw, -6.3vw);
  }

  .koshinetsuHokuriku & {
    transform: scale(5.71) translate(-9.9vw, -2.5vw);
  }

  .tokaiChubu & {
    transform: scale(5.71) translate(-6.9vw, -10.6vw);
  }

  .chugokuShikoku & {
    transform: scale(5.71) translate(20.1vw, -12.6vw);
  }

  .kinki & {
    transform: scale(5.71) translate(5vw, -15.1vw);
  }

  .kyushuOkinawa & {
    transform: scale(5.71) translate(39.4vw, -21vw);
  }

  @include mixins.media() {
    top: 20px;
    left: 50%;
    margin-left: -171px;
    width: 342px;
    height: 280px;
    transform: none;

    .hokkaidoTohoku & {
      transform: scale(5.71) translate(-92px, 60px);
    }

    .kanto & {
      transform: scale(5.71) translate(-68px, -55px);
    }

    .koshinetsuHokuriku & {
      transform: scale(5.71) translate(-34px, -7px);
    }

    .tokaiChubu & {
      transform: scale(5.71) translate(-24px, -57px);
    }

    .chugokuShikoku & {
      transform: scale(5.71) translate(69px, -68px);
    }

    .kinki & {
      transform: scale(5.71) translate(17px, -73px);
    }

    .kyushuOkinawa & {
      transform: scale(5.71) translate(134px, -100px);
    }
  }
}

.searchHospital_inner {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 100%;
  transition: transform 0.2s ease;

  > div {
    flex-basis: 50%;
  }

  .second > & {
    transform: translateX(-50%);
  }
}

.searchHospital_description {
  display: flex;
  align-items: center;
  position: absolute;
  top: 9.3vw;
  left: 0;
  height: 50px;
  padding-right: 10px;
  padding-left: 45px;
  font-size: 1.2rem;
  line-height: 1.5;
  background: #fff url('~@/assets/images/icon/ping.svg') no-repeat 17px center;
  background-size: 20px 30px;

  @include mixins.media() {
    top: 20px;
  }
}

.balloon {
  position: absolute;
  top: 0;
  left: 0;
  width: 20vw;
  height: 20vw;
  border: 1px solid var.$color-main;
  border-radius: 10px;
  background-color: #fff;
  line-height: 1.07;
  font-weight: 600;
  color: var.$color-main-text;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);

  &:hover {
    opacity: 1;
    background-color: #e7f8f6;
  }

  &.hokkaidoTohoku {
    top: 14vw;
    left: 73vw;
  }
  &.kanto {
    top: 46vw;
    left: 73vw;
  }
  &.koshinetsuHokuriku {
    top: 27vw;
    left: 49vw;
  }
  &.tokaiChubu {
    top: 64vw;
    left: 53vw;
  }
  &.chugokuShikoku {
    top: 35vw;
    left: 21vw;
  }
  &.kinki {
    top: 73vw;
    left: 30vw;
  }
  &.kyushuOkinawa {
    top: 74vw;
    left: 7vw;
  }

  @include mixins.media() {
    &.hokkaidoTohoku {
      top: 50%;
      left: 25%;
      margin-left: 128px;
      margin-top: -100px;
    }
    &.kanto {
      top: 50%;
      left: 25%;
      margin-left: 110px;
      margin-top: 0px;
    }
    &.koshinetsuHokuriku {
      top: 50%;
      left: 25%;
      margin-left: -20px;
      margin-top: -80px;
    }
    &.tokaiChubu {
      top: 50%;
      left: 25%;
      margin-left: 10px;
      margin-top: 66px;
    }
    &.chugokuShikoku {
      top: 50%;
      left: 25%;
      margin-left: -120px;
      margin-top: -50px;
    }
    &.kinki {
      top: 50%;
      left: 25%;
      margin-left: -75px;
      margin-top: 80px;
    }
    &.kyushuOkinawa {
      top: 50%;
      left: 25%;
      margin-left: -185px;
      margin-top: 80px;
    }
  }

  @include mixins.media() {
    width: 75px;
    height: 75px;
  }

  button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    &::after {
      display: inline-block;
      content: '';
      position: absolute;
      right: 5px;
      bottom: 5px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0 15px 15px;
      border-color: transparent transparent var.$color-accent transparent;
    }
  }
}

.arrowLeft {
  &::before,
  &::after {
    display: inline-block;
    content: '';
    position: absolute;
    left: -8px;
    top: 50%;
    width: 0;
    height: 0;
    transform: translateY(-50%);
    border-style: solid;
  }

  &::before {
    border-width: 6.5px 7px 6.5px 0;
    border-color: transparent var.$color-main transparent transparent;
  }

  &::after {
    left: -7px;
    border-width: 5.5px 7px 5.5px 0;
    border-color: transparent #fff transparent transparent;
  }
}

.arrowTop {
  &::before,
  &::after {
    display: inline-block;
    content: '';
    position: absolute;
    top: -8px;
    left: 50%;
    width: 0;
    height: 0;
    transform: translateX(-50%);
    border-style: solid;
  }

  &::before {
    border-width: 0 6.5px 7px 6.5px;
    border-color: transparent transparent var.$color-main transparent;
  }

  &::after {
    top: -7px;
    border-width: 0 5.5px 7px 5.5px;
    border-color: transparent transparent #fff transparent;
  }
}

.arrowBottom {
  &::before,
  &::after {
    display: inline-block;
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    width: 0;
    height: 0;
    transform: translateX(-50%);
    border-style: solid;
  }

  &::before {
    border-width: 7px 6.5px 0 6.5px;
    border-color: var.$color-main transparent transparent transparent;
  }

  &::after {
    bottom: -7px;
    border-width: 7px 5.5px 0 5.5px;
    border-color: #fff transparent transparent transparent;
  }
}

.balloon.arrowLeft:hover::after {
  border-color: transparent #e7f8f6 transparent transparent;
}
.balloon.arrowTop:hover::after {
  border-color: transparent transparent #e7f8f6 transparent;
}
.balloon.arrowBottom:hover::after {
  border-color: #e7f8f6 transparent transparent transparent;
}

.searchHospital_areaLabel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  margin-top: 12.5vw;
  margin-bottom: 6.6vw;
  background-color: #fff;
  text-align: center;
  font-size: 2.2rem;
  color: var.$color-main-text;

  @include mixins.media() {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  &::after {
    display: inline-block;
    content: '';
    flex-basis: 29.3%;
    order: 3;
  }

  > .name {
    order: 2;
    flex-basis: 41.4%;
  }

  > .backWrap {
    order: 1;
    margin-left: 16px;
    flex-basis: 29.3%;
  }

  .back {
    display: flex;
    align-items: center;
    height: 50px;
    font-size: 1.4rem;

    &::before {
      content: '';
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 4px;
      border-left: 3px solid var.$color-main;
      border-top: 3px solid var.$color-main;
      transform: rotate(-45deg) translateY(-1px);
      margin-left: 4px;
      transition: border-color 0.1s;
    }
  }
}

.searchHospital_choiceArea {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 50px;
  margin-left: 7px;
  margin-right: 7px;

  > li {
    margin: 9px;
    flex-basis: calc(33.3% - 18px);
  }
}

.choiceButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
  padding: 12px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);

  &::after {
    content: '';
    display: inline-block;
    width: 9px;
    height: 9px;
    border-right: 2px solid var.$color-main;
    border-bottom: 2px solid var.$color-main;
    transform: rotate(-45deg) translateY(-1px);
    margin-left: 4px;
    transition: border-color 0.1s;
  }
}
</style>
